import { addFilter } from 'portaltransparencia-common/libs/AddFilter';
import StorageService from 'portaltransparencia-common/libs/StorageService';

export const SORT_PADRAO = [
  { property: 'emendaParlamentar.numero', direction: 'desc' },
  { property: 'numeroEmpenho', direction: 'desc' }
];

const EMENDA_EMPENHO_FILTERS = [
  'numeroEmenda',
  'nomeAutor',
  'tipoTransferencia',
  'planoAcao',
  'cnpjCpf',
  'nomeFornecedor',
  'empenhoInicial',
  'empenhoFinal',
  'dataInicial',
  'dataFinal',
  'dataInicioMovimentacao',
  'dataFimMovimentacao'
];

const PROGRAMATICA_FILTERS = [
  'orgao',
  'unidade',
  'funcao',
  'subFuncao',
  'programa',
  'projeto',
  'elemento',
  'despesa',
  'fonteRecurso'
];

const PROGRAMATICA_PREFIX = 'programatica.';

export function buildParamsQuery(filters) {
  const urlFilter = [];

  EMENDA_EMPENHO_FILTERS.forEach(filterName => {
    addFilter(urlFilter, filterName, filters.get(filterName));
  });

  PROGRAMATICA_FILTERS.forEach(filterName => {
    const item = filters.get(filterName);
    if (item) {
      addFilter(
        urlFilter,
        PROGRAMATICA_PREFIX + filterName,
        item.get('codigo')
      );
    }
  });

  return urlFilter.join('&');
}

export function buildSortQuery(page) {
  const sort = page && page.get('sort');

  if (typeof sort === 'string' && sort) {
    return `sort=${sort}`;
  }

  const sortList =
    sort && sort.size
      ? sort.toJS().filter(({ property, direction }) => property && direction)
      : SORT_PADRAO;

  return sortList
    .map(({ property, direction }) => `sort=${property},${direction}`)
    .join('&');
}

export function buildUrl(url, filters, page) {
  const userInfo = StorageService.getItem('userInfo');
  const { entidade, exercicio } = userInfo;
  const base = `${url}?entidade=${entidade.id}&exercicio=${exercicio.id}`;
  const paramsQuery = filters ? buildParamsQuery(filters) : '';
  const pageQuery = page ? buildPageQuery(page) : '';

  return [base, paramsQuery, pageQuery].filter(Boolean).join('&');
}

function buildPageQuery(page) {
  const params = [];

  if (page.get('number')) {
    params.push(`page=${page.get('number')}`);
  }

  if (page.get('size')) {
    params.push(`size=${page.get('size')}`);
  }

  params.push(buildSortQuery(page));

  return params.filter(Boolean).join('&');
}
